import { ChakraBox as Box } from "@airhelp/react-ui-components";

export interface SpacerProps {
  hDesktop: string;
  hMobile: string;
}

const Spacer = ({ hDesktop, hMobile }: SpacerProps) => <Box h={{ base: hMobile, lg: hDesktop }} />;

export default Spacer;
